import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomHelpComponent } from './custom-help.component';
import {CmsConfig, ConfigModule} from '@spartacus/core';
import {CustomCmsItemModule} from '../custom-cms-item/custom-cms-item.module';
import {MediaModule} from '@spartacus/storefront';
import {CustomIconsModule} from '../../../icons/custom-icons.module';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [CustomHelpComponent],
    imports: [
        CommonModule,
        ConfigModule.withConfig({
            cmsComponents: {
                HelpComponent: {
                    component: CustomHelpComponent,
                },
            },
        } as CmsConfig),
        CustomCmsItemModule,
        MediaModule,
        CustomIconsModule,
        RouterModule,
    ]
})
export class CustomHelpModule { }
